import React from 'react'
import MaskedInput from 'react-text-mask'
export const CpfField = ({ inputRef, ...rest }) => {
  return (
    <MaskedInput
      {...rest}
      mask={[
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '.',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/
      ]}
      placeholderChar={'\u2000'}
    />
  )
}

export default CpfField



// WEBPACK FOOTER //
// ./src/components/Fields/CpfField.js